<template>
  <div class="switch">
    <div class="switch-toggle">
      <input type="checkbox" @input="updateValue" :checked="modelValue" :aria-label="label">
      <span class="slider"></span>
    </div>
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'dx-switch',
  props: {
    label: String,
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
</script>

<style scoped lang="scss">
input[type=checkbox] {
  z-index: 10;
}

.switch {
  padding: var(--dx-space-size--xs);
  height: 56px;
}

.switch-toggle {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  padding: var(--dx-space-size--xs);
  margin: 10px 7px -5px 20px;
}

.switch-toggle input {
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  cursor: pointer;
  position: absolute;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

</style>
